module.exports = __webpack_public_path__ + "assets/img/Slice 164(1).3212268e.png";